import apiWorker from '../apiWorker'

export default {

    create : (data) => apiWorker('post',  `/api/v1/core/template_docs_sent_events/create`, data, true),

}
